import React from 'react'
import { load } from 'ts-dotenv'

const env = load({
  REACT_APP_UPLOAD_URL: String,
})

export const sendFiles = (flow: string, logoFiles: never[], saveData: (value: string[]) => void, setIsLoading: React.Dispatch<React.SetStateAction<boolean>>, filesChanged?: boolean) => {
  if ((logoFiles.length && (filesChanged !== undefined && filesChanged)) || (logoFiles.length && filesChanged === undefined)) {
    setIsLoading(true)
    const formData = new FormData()
    // @ts-ignore
    formData.append('file[]', logoFiles[0], logoFiles[0].name)
    if (logoFiles.length === 2) {
      // @ts-ignore
      formData.append('file[]', logoFiles[1], logoFiles[1].name)
    }
    const request = new Request(`${env.REACT_APP_UPLOAD_URL}&form_id=${flow}`, {
      method: 'POST',
      body: formData,
      redirect: 'follow'
    })
    fetch(request)
    .then(res => res.text())
    .then(result => {
      setIsLoading(false)
      saveData(JSON.parse(result).data)
    })
  } else {
    saveData([])
  }
}
